export const css = {
    root: 'UBWJvJ6t',
    output: '_1S6I1qSx',
    bar: '_2WdiUG6V',
    progress: '_27qhPGbJ',
    ' _key': 'afcpe-theme/dojo/progress'
};
export default css;
